module.exports = __webpack_public_path__ + "img/dmartin.45d039cd.png";